import { LogoTwoLines, LogoTwoLinesPartake } from 'app/design/branding/logo';
import { useDeviceWidth } from 'app/hooks/use-device-size';
import { env } from 'app/lib/env';
import Animated, { FadeInUp, FadeOutUp } from 'react-native-reanimated';
import { SPLASH_ENTRANCE_DURATION_MS } from './splash.constants';

export function DefaultSplashLogo() {
  const width = useDeviceWidth();

  return (
    <Animated.View entering={FadeInUp.duration(SPLASH_ENTRANCE_DURATION_MS)} exiting={FadeOutUp.duration(500)}>
      {env.IS_PARTAKE ? (
        <LogoTwoLinesPartake color="#161616" height={width * 0.7} width={width * 0.7} />
      ) : (
        <LogoTwoLines color="#161616" height={width * 0.7} width={width * 0.7} />
      )}
    </Animated.View>
  );
}
